import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect';
import BookingService from './../../../../services/cargobooking.service';

export default {
  name: 'create-delivery',
  components: {
    Paginate,
    BasicSelect,
    Multiselect,
    VueElementLoading
  },
  props: ['selectedEditRowData'],
  data () {
    return {
      isLoading:false,
      updateID:'',
      dcsitcode:'',
      companyname:'',
      spocperson:'',
      email:'',
      pincode:'',
      address:'',
      contactno:'',
      gstno:'',
      userName:''
    }
  },
  computed: {
  },
  async mounted () {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    if(this.selectedEditRowData.id){
      this.updateID = this.selectedEditRowData.id;
      this.dcsitcode = this.selectedEditRowData.dcsitcode;
      this.companyname = this.selectedEditRowData.companyname;
      this.spocperson = this.selectedEditRowData.spocperson;
      this.email = this.selectedEditRowData.email;
      this.pincode = this.selectedEditRowData.pincode;
      this.address = this.selectedEditRowData.address;
      this.contactno = this.selectedEditRowData.contactno;
      this.gstno = this.selectedEditRowData.gstno;
    }
  },
  methods: {
    isIntegerOnlty: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    showCreateDeliveryDetailsData() {
      this.$emit("goBackToParent")
    },
    async SaveDeliveryDetails(){
      try {
        var inputPayload = {};
        if(this.updateID){
          inputPayload.deliveryid = this.updateID;
        }
        inputPayload.dcsitcode = this.dcsitcode;
        inputPayload.companyname = this.companyname;
        inputPayload.spocperson = this.spocperson;
        inputPayload.email = this.email;
        inputPayload.pincode = this.pincode;
        inputPayload.address = this.address;
        inputPayload.contactno = this.contactno;
        inputPayload.gstno = this.gstno;
        inputPayload.lastmodifiedby = this.userName;
        this.isLoading = true;
        let result = await BookingService.saveB2BDeliveryDetails(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.$alert(result.data.message, this.dcsitcode, "success");
          this.$emit("goBackToParent");
        }else{
          this.$alert(result.data.message, this.dcsitcode, "error");
        }
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    onSubmit: function() {
      var self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.SaveDeliveryDetails(event);
        }else{
          console.log('errors exist', this.errors)
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/B2BMarketPlace/DeliveryDetails/CreateDeliveryDetails/CreateDeliveryDetails.component.js